import Controller from "./bulkInvoiceItemTypesUploadDetails.controller";
import template from "./bulkInvoiceItemTypesUploadDetails.html";

const bulkInvoiceItemTypesUploadDetails = {
  template,
  controller: Controller,
};

export default bulkInvoiceItemTypesUploadDetails;



// WEBPACK FOOTER //
// ./src/pages/bulkInvoiceItemTypesUploadDetails/bulkInvoiceItemTypesUploadDetails.component.js